module.exports = __webpack_public_path__ + "img/5.d22d3ebf.jpg";